
/*
export function areAllPrerequsMet(data,prerequisites) {
   return prerequisites.every(requirement => data[requirement.ident] == requirement.answer);
}*/

export function meetsRequirements(data,condition) {
   const reserved = ['true','false'];
//   console.log(condition);
   return eval(condition.replace(/\w+/gmi, match => reserved.includes(match) ? match : (data[match] ?? true)));
}

export function convertAbbreviated(abbreviatedString,conversionsDict,joiner=' · ') {
   return abbreviatedString.split('').map(letter => conversionsDict[letter]).join(joiner);
}

export function fullstopize(abbrStr) {
   return abbrStr.split('').map(c => c + '.').join('');
}

export function sum(coll) {
   return coll.reduce((prev,cur) => prev + cur,0);
}

function base64ToUint8(base64) {
   var binaryString = atob(base64);
   var bytes = new Uint8Array(binaryString.length);
   for (var i = 0; i < binaryString.length; i++) {
     bytes[i] = binaryString.charCodeAt(i);
   }
   return bytes;
}

export function decompressServe(data) {
   return JSON.parse(new TextDecoder().decode(brotli(base64ToUint8(data))));
}